import { Box3, Sphere } from 'three';

const itemSize = 3;
const box = { min: [0, 0, 0], max: [0, 0, 0] };

function bounds(positions: ArrayLike<number>) {
  const count = positions.length / itemSize;
  box.min[0] = positions[0];
  box.min[1] = positions[1];
  box.max[0] = positions[0];
  box.max[1] = positions[1];

  for (let i = 0; i < count; i++) {
    const x = positions[i * itemSize + 0];
    const y = positions[i * itemSize + 1];
    const z = positions[i * itemSize + 2];
    box.min[0] = Math.min(x, box.min[0]);
    box.min[1] = Math.min(y, box.min[1]);
    box.min[2] = Math.min(z, box.min[2]);
    box.max[0] = Math.max(x, box.max[0]);
    box.max[1] = Math.max(y, box.max[1]);
    box.max[2] = Math.max(z, box.max[2]);
  }
}

export function computeBox(positions: ArrayLike<number>, output: Box3) {
  bounds(positions);
  output.min.set(box.min[0], box.min[1], box.min[2]);
  output.max.set(box.max[0], box.max[1], box.max[2]);

  return output;
}

export function computeSphere(positions: ArrayLike<number>, output: Sphere) {
  bounds(positions);
  const minX = box.min[0];
  const minY = box.min[1];
  const minZ = box.min[2];
  const maxX = box.max[0];
  const maxY = box.max[1];
  const maxZ = box.max[2];
  const width = maxX - minX;
  const height = maxY - minY;
  const depth = maxZ - minZ;
  const length = Math.sqrt(width * width + height * height + depth * depth);
  output.center.set(minX + width / 2, minY + height / 2, minZ + depth / 2);
  output.radius = length / 2;
}
